<template>
  <div class="feedback">
    <div v-if="!feedbackSent">
      <AlertMessage type="error" v-if="errorMessage">{{errorMessage}}</AlertMessage>
      <strong id="feedback-title">{{$t('feedback.title')}}</strong>
      <div role="radiogroup" :aria-label="$t('feedback.title')">
        <ul class="feedback__select" role="list">
          <li
            v-for="item in items"
            :key="item.cssClass"
            :class="{'active': form.rating === item.value}"
          >
            <label>
              <input
                class="visually-hidden"
                type="radio"
                :name="ratingName"
                :value="item.value"
                v-model="form.rating"
                :aria-label="$t(item.labelKey)"
              />
              <i :class="item.cssClass" aria-hidden="true"></i>
            </label>
          </li>
        </ul>
      </div>
      <div class="input-group" v-if="form.rating !== null">
        <label for="feedback-comment">{{$t('feedback.comment.label')}}</label>
        <textarea id="feedback-comment" name="comment" v-model="form.comment" :aria-label="$t('feedback.comment.label')"></textarea>
        <Button
          @click="sendFeedback"
          class="button button--primary button--cta"
          :loading="loading"
        >{{$t('feedback.send')}}</Button>
      </div>
    </div>
    <Modal v-if="feedbackSent" @close="reset">
      <strong>{{$t('feedback.modal.title')}}</strong>
      <p>{{$t('feedback.modal.text')}}</p>
    </Modal>
  </div>
</template>

<script>
import { useId } from "vue";
import Modal from "@/components/common/Modal";
import AlertMessage from "@/components/common/AlertMessage";
import FeedbackService from "@/services/FeedbackService";

export default {
  name: "Feedback",
  components: {
    Modal,
    AlertMessage
  },
  setup() {
    return {
      ratingName: `feedback-rating-${useId()}`
    };
  },
  data() {
    return {
      api: new FeedbackService(),
      errorMessage: "",
      items: [
        { cssClass: "fas fa-grin-beam", value: 5, labelKey: "feedback.rating.5" },
        { cssClass: "fas fa-smile-beam", value: 4, labelKey: "feedback.rating.4" },
        { cssClass: "fas fa-meh", value: 3, labelKey: "feedback.rating.3" },
        { cssClass: "fas fa-frown", value: 2, labelKey: "feedback.rating.2" },
        { cssClass: "fas fa-sad-tear", value: 1, labelKey: "feedback.rating.1" }
      ],
      form: {
        rating: null,
        comment: ""
      },
      feedbackSent: false,
      loading: false
    };
  },
  methods: {
    reset() {
      this.feedbackSent = false;
      this.form.comment = "";
      this.form.rating = null;
      this.errorMessage = "";
    },
    sendFeedback() {
      this.loading = true;
      this.api
        .postFeedback({
          comment: this.form.comment,
          rating: this.form.rating
        })
        .then(res => {
          this.feedbackSent = true;
          this.loading = false;
          try {
            if (window.localStorage)
              localStorage.setItem("feedback-sent", new Date().toString());
          } catch (err) {
            console.log(err);
          }
        })
        .catch(e => {
          this.loading = false;
          this.errorMessage =
            "Something wen't wrong. Could not send feedback. Please try to send it again.";
        });
    }
  },
  mounted() {
    this.loading = false;
  }
};
</script>

<style lang="scss">
@use "@/assets/scss/abstracts/_variables.scss" as *;
.feedback {
  .feedback__select {
    list-style: none;
    font-size: 1.8rem;
    padding: 1rem 0 0 0;
    li {
      display: inline-block;
      margin-right: 1rem;
      label {
        @include font-primary-regular;
        display: inline-block;
        font-size: 1.2em;
        color: $greyBlueMidDark;
        background: none;
        border: none;
        cursor: pointer;
        margin: 0;
        padding: 0;
        line-height: inherit;
        letter-spacing: 0.8px;
        
        i {
          transition: transform 0.15s ease-in-out;
        }
        i:hover {
          transform: scale(1.1);
        }

        input:focus-visible + i {
          outline: 2px solid currentColor;
          outline-offset: 3px;
        }
      }

      &.active {
        label {
          color: $blueMedium;
          i {
            transform: scale(1.3);
          }
        }
      }
    }
  }
  .input-group {
    textarea,
    label {
      display: block;
    }
    textarea {
      min-height: 100px;
      width: 100%;
    }
  }

  /*button {
    .loader-icon {
      margin: 0;
      top: 0.3rem;
      margin-right: 0.5rem;
    }
  }*/
}
</style>